// src/utils/models/userModel.js

export const USER_ROLES = {
  ADMIN: "admin",
  CEO: "ceo",
  ACCOUNTING: "accounting",
  COMMERCIAL: "commercial",
};

export const USER_ROLES_LABELS = {
  [USER_ROLES.ADMIN]: "Administrador",
  [USER_ROLES.CEO]: "CEO",
  [USER_ROLES.ACCOUNTING]: "Contabilidad",
  [USER_ROLES.COMMERCIAL]: "Comercial",
};

export const ROLE_PERMISSIONS = {
  [USER_ROLES.ADMIN]: {
    canViewAll: true,
    canEditAll: true,
    canDeleteAll: true,
    modules: ['contacts', 'projects', 'billing', 'calendar', 'settings', 'chat'],
  },
  [USER_ROLES.CEO]: {
    canViewAll: true,
    canEditAll: true,
    canDeleteAll: true,
    modules: ['contacts', 'projects', 'billing', 'calendar', 'chat'],
  },
  [USER_ROLES.ACCOUNTING]: {
    canViewAll: true,
    canEditAll: true,
    canDeleteAll: true,
    modules: ['billing', 'contacts'],
  },
  [USER_ROLES.COMMERCIAL]: {
    canViewAll: false,
    canEditAll: false,
    canDeleteAll: false,
    modules: ['clients', 'contacts', 'proposals'],
    restrictedSections: {
      clients: ['view', 'create', 'edit'],
      contacts: ['view', 'create'],
      proposals: ['view', 'create'],
    }
  },
};

export const getUserRoleLabel = (roleId) => {
  // Nota: roleId ahora es un ID dinámico de Firestore, no un string fijo
  // Esta función se mantiene por compatibilidad, pero se recomienda usar
  // la colección "roles" de Firestore para obtener el nombre real
  if (!roleId) return "Sin rol";
  
  // Buscar en roles estáticos (compatibilidad hacia atrás)
  const staticRole = Object.entries(USER_ROLES).find(([_, value]) => value === roleId);
  if (staticRole) return USER_ROLES_LABELS[staticRole[1]];
  
  // Si no es un rol estático, devolver el ID como fallback
  return roleId;
};

export const createUserProfile = (data) => ({
  // ID del documento en Firestore (generado automáticamente)
  id: '',
  
  // UID único del usuario (puede ser el UID de Firebase Auth o generado)
  uid: data.uid || '',
  
  // Datos básicos
  email: data.email || '',
  displayName: data.displayName || '',
  
  // Rol (ID del rol en la colección "roles" de Firestore)
  role: data.role || '',
  
  // Datos adicionales
  department: data.department || '',
  phone: data.phone || '',
  avatar: data.avatar || '',
  
  // Fechas
  createdAt: data.createdAt || new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  lastLogin: data.lastLogin || null, // null = nunca ha iniciado sesión
  
  // Estado
  isActive: data.isActive !== undefined ? data.isActive : true,
  
  // Auditoría
  createdBy: data.createdBy || '',
  updatedBy: data.updatedBy || '',
});

export const userSchema = {
  uid: '',
  email: '',
  displayName: '',
  role: '',
  department: '',
  phone: '',
  avatar: '',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  lastLogin: null,
  isActive: true,
  createdBy: '',
  updatedBy: '',
};